import { Injectable } from "@angular/core";
import { NavigationEnd, Router } from "@angular/router";

@Injectable({
  providedIn: "root",
})
export class ModuleService {
  module: "Billing Meter" | "New Product Onboarding" | "Lionrock" | "Planned" | "Administrator" | "SelfService" | "FFP" | "PF" | "CapacityBlueprint" | "Landing";

  constructor(private router: Router) {
    router.events.subscribe((evt) => {
      function match(evt: NavigationEnd, start: string) {
        return evt.urlAfterRedirects.startsWith(start);
      }

      // The landing page is the root route, so it needs an exact match; every URL starts with "/".
      function isRoot(evt: NavigationEnd) {
        return evt.urlAfterRedirects.split(/[?#]/)[0] === "/";
      }

      if (evt instanceof NavigationEnd && !match(evt, "/404")) {
        if (isRoot(evt) || match(evt, "/aad-callback")) this.module = "Landing";
        else if (match(evt, "/prep/")) this.module = "Billing Meter";
        else if (match(evt, "/product-onboard-status")) this.module = "Billing Meter";
        else if (match(evt, "/planned/") || match(evt, "/plans")) this.module = "Planned";
        else if (match(evt, "/admin-view/") || match(evt, "/incidents-view/") || match(evt, "/approver-admin"))
          this.module = "Administrator";
        else if (match(evt, "/self-service/")) this.module = "SelfService";
        else if (match(evt, "/ffp/")) this.module = "FFP";
        else if (match(evt, "/pf/")) this.module = "PF";
        else if (match(evt, "/capacity/")) this.module = "CapacityBlueprint";
        else this.module = "Lionrock";
      }
    });
  }
}
